/* eslint-disable import/no-cycle */
import { HStack, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';

const path = 'maxLength';

export const MaxAnswerLengthInput = React.memo(function MaxAnswerLengthInput({ id }: { id: string }) {
  const { t } = useTranslation('questionnaireTemplate');

  const value = QuestionnaireTemplateStore.useStoreState((state) => state.getElementValue(id, path));
  // const error = useFieldError({ elementId: id, path });
  // const updateElementValue = useUpdateElementValue();

  return (
    <HStack align="center" justify="flex-end">
      <Text fontSize="sm" pt={1}>
        {t('formBuilder.canvas.element.maxCharactersInputLabel')}
      </Text>
      <Text fontSize="sm" pt={1}>
        {value}
      </Text>
      {/* <FormControl isInvalid={!!error} maxWidth="100px">
        <NumberInput
          size="sm"
          width="100%"
          value={value ?? ''}
          isInvalid={!!error}
          isDisabled
          onChange={(valueAsString, valueAsNumber) => {
            if (valueAsString === '' || valueAsString === undefined) {
              updateElementValue({ id, path, value: undefined });
            }
            // eslint-disable-next-line no-restricted-globals
            else if (!isNaN(valueAsNumber) && valueAsNumber >= 1) {
              updateElementValue({ id, path, value: valueAsNumber });
            }
          }}
          aria-invalid={!!error}
        >
          <NumberInputField
            borderRadius="md"
            placeholder={t('formBuilder.canvas.element.maxCharactersInputPlaceholder')}
            data-testid="max-answer-length-input"
            data-error-key={`${id}.${path}`}
          />
        </NumberInput>
        {error && (
          <FormErrorMessage fontSize="xs" width="max-content">
            {t(error.message, error?.context)}
          </FormErrorMessage>
        )}
      </FormControl> */}
    </HStack>
  );
});
